import { TouchBackendOptions } from './interfaces';

export class OptionsReader implements TouchBackendOptions {
    public enableTouchEvents = true;
    public enableMouseEvents = false;
    public enableKeyboardEvents = false;
    public ignoreContextMenu = false;
    public touchSlop = 0;
    private context: any;

    public constructor(incoming: TouchBackendOptions, context?: any) {
        this.context = context;

        Object.keys(incoming).forEach((key) => {
            if ((incoming as any)[key] != null) {
                (this as any)[key] = (incoming as any)[key];
            }
        });
    }

    public get window() {
        if (this.context && this.context.window) {
            return this.context.window;
        } else if (typeof window !== 'undefined') {
            return window;
        }
        return undefined;
    }

    public get document() {
        if (this.window) {
            return this.window.document;
        }
        return undefined;
    }
}
